import sileo from 'sileo';

/*
 * Ticket-Board related models
 **/

const NavbarBoards = new sileo.Model('board', 'ticket-tracker-board');
const TicketBoardCardDetails = new sileo.Model('board', 'ticket-board-card-details');
const TicketCards = new sileo.Model('board', 'ticket-tracker-display-card');
const TicketFeedback = new sileo.Model('board', 'ticket-feedback');
const TicketBoardLinkedTickets = new sileo.Model('board', 'ticket-board-linked-tickets');
const TicketReopen = new sileo.Model('board', 'ticket-reopen');
const TicketIssuerQuery = new sileo.Model('board', 'ticket-issuer-query');
const TicketCancellation = new sileo.Model('board', 'cancel-ticket');
const InterestedParty = new sileo.Model('board', 'interested-party');
const TicketTrackerToDos = new sileo.Model('board', 'ticket-tracker-todos');
const BoardAnalytics = new sileo.Model('board', 'board-analytics');
const CardActivity = new sileo.Model('board', 'card-activity');
const ExternalChannelSubscriber = new sileo.Model('board', 'external-channel-subscriber');
const BoardAnalyticsConfig = new sileo.Model('board', 'board-analytics-config');

const state = {
    queriedTicketCard: null,
};

const mutations = {
    setqueriedTicketCard(state, handlerCard) {
        state.queriedTicketCard = handlerCard;
    },
};

const actions = {

    cancelTicket(_, { filters, data }) {
        const form = new FormData();

        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });
        return TicketCancellation.objects.update(filters, form);
    },

    getCardDetails(context, pk) {
        return TicketBoardCardDetails.objects.get(pk);
    },


    fetchBoards(context, filters) {
        return NavbarBoards.objects.filter(filters).then(data => {
            data.addExistingBoards = !filters.resetBoards;
            return data.objects;
        }).catch(e => {
            console.error('Error fetching boards', e);
            return [];
        });
    },

    fetchTicketCards(context, filters) {
        return TicketCards.objects.filter(filters);
    },

    submitTicketFeedback(context, data) {
        const form = new FormData();

        Object.entries(data).forEach(([key, value]) => {
            form.append(key, value);
        });

        return TicketFeedback.objects.create(form);
    },

    updateTicketFeedback(context, data) {
        const form = new FormData();

        Object.entries(data).forEach(([key, value]) => {
            form.append(key, value);
        });

        return TicketFeedback.objects.update({ pk: data.pk }, form);
    },

    fetchTicketFeedback(context, filters) {
        return TicketFeedback.objects.filter(filters);
    },

    fetchHasLinkedTickets(context, filters) {
        return TicketBoardLinkedTickets.objects.filter(filters);
    },

    updateHasLinkedTickets(context, filters) {
        return TicketBoardLinkedTickets.objects.update(filters);
    },

    reopenTicket(context, { filters, data }) {
        const form = new FormData();

        Object.entries(data).forEach(([key, value]) => {
            form.append(key, value);
        });

        return TicketReopen.objects.update(filters, form);
    },

    queryTicketIssuer({ commit }, pk) {
        return TicketIssuerQuery.objects.get(pk).then(function (data) {
            commit('setqueriedTicketCard', data);
            return data;
        });
    },

    updateInterestedParty(context, data) {
        let form = new FormData();
        for (let [key, value] of Object.entries(data)) {
            form.append(key, value);
        }
        return InterestedParty.objects.update({ pk: data.pk }, form);
    },

    fetchTicketTrackerToDos(context, filters) {
        return TicketTrackerToDos.objects.filter(filters);
    },

    fetchBoardAnalytics(context, filters) {
        return BoardAnalytics.objects.filter(filters);
    },

    fetchCardActivities(context, filters) {
        return CardActivity.objects.filter(filters);
    },

    inviteExternalInterestedParty(context, data) {
        const form = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            form.append(key, value);
        });
        return ExternalChannelSubscriber.objects.create(form);
    },

    fetchBoardAnalyticsConfig(context, filters) {
        return BoardAnalyticsConfig.objects.filter(filters);
    },

    updateBoardAnalyticsConfig(context, { boardId, widgets }) {
        const form = new FormData();
        form.append('board_id', boardId);
        form.append('widgets', JSON.stringify(widgets));
        return BoardAnalyticsConfig.objects.update({}, form);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
